const generateOverlayText = (editMode) => (
  editMode ? 'Updating Care Team member...' : 'Creating Care Team member...'
);

export default generateOverlayText;
